export default __webpack_public_path__ + "static/media/img-6.3eabf7a2.jpg";